export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/@ngx-translate/http-loader/index.js
// module id = ../../../../@ngx-translate/http-loader/index.js
// module chunks = 5